import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61c7dfa8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_3 = { class: "data--aligncenter aligndata--separate5" }
const _hoisted_4 = { class: "cookiessettings--subtitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectButton = _resolveComponent("SelectButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: _ctx.headermsg,
    visible: _ctx.display,
    "onUpdate:visible": [
      _cache[2] || (_cache[2] = ($event: any) => ((_ctx.display) = $event)),
      _ctx.closeDialog
    ],
    style: {width: '35vw'},
    position: "left"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveAndCloseDialog && _ctx.saveAndCloseDialog(...args))),
        class: "p-button-text button__general",
        value: "Cancel"
      }, _toDisplayString(_ctx.$t('menu.saveandclose')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('cookies.bannerfirsttext')), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('cookies.bannersecondtext')), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('cookies.bannerthirdtext')), 1),
        _createElementVNode("a", {
          target: "blank",
          href: _ctx.cookiespolicyurl
        }, _toDisplayString(_ctx.$t('cookies.cookiespolicy')), 9, _hoisted_1),
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('cookies.analyticcookiestitle')), 1),
          _createVNode(_component_SelectButton, {
            modelValue: _ctx.analyticscookiesenabled,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.analyticscookiesenabled) = $event)),
            options: _ctx.analyticsoptions,
            optionLabel: "name",
            optionValue: "value",
            "aria-labelledby": "single"
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('cookies.analyticcookiestext')), 1)
      ])
    ]),
    _: 1
  }, 8, ["header", "visible", "onUpdate:visible"]))
}